import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import SurfaceSection from '../Common/SurfaceSection';


export const ProgressBarSection = styled(SurfaceSection)`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
`;

export const ChartFlexContainer = styled(Box)`
    align-self: stretch;
    flex: 1;
    min-height: ${({ theme }) => theme.spacing(25)};
    ${({ theme }) => theme.breakpoints.up('md')} {
        min-height: 0;
    }
`;
